import { createSlice } from "@reduxjs/toolkit"
import { EmailLog } from "@/types"
import { fetchEmailLogs } from "./emailLogsThunks"

interface EmailLogsState {
  logs: EmailLog[]
  loading: boolean
  loaded: boolean
  error: string | null
}

const initialState: EmailLogsState = {
  logs: [],
  loading: false,
  loaded: false,
  error: null,
}

const emailLogsSlice = createSlice({
  name: "emailLogs",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmailLogs.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchEmailLogs.fulfilled, (state, action) => {
        state.loading = false
        state.loaded = true
        state.logs = action.payload
      })
      .addCase(fetchEmailLogs.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload || "Failed to fetch email logs"
      })
  },
})

export default emailLogsSlice.reducer
